import React from 'react';

import { useTronWallet } from '@/networks/tron';

import HeaderWalletDrawerTronWalletConnect from './HeaderWalletDrawerTronWalletConnect';
import HeaderWalletDrawerTronWalletDetails from './HeaderWalletDrawerTronWalletDetails/HeaderWalletDrawerTronWalletDetails';

interface HeaderWalletDrawerTronWalletProps {
  // Add any props you may need here
}

const HeaderWalletDrawerTronWallet: React.FC<HeaderWalletDrawerTronWalletProps> = () => {
  const { isConnected } = useTronWallet();

  if (isConnected) {
    return <HeaderWalletDrawerTronWalletDetails />;
  }

  return <HeaderWalletDrawerTronWalletConnect className="h-14 w-full rounded-xl text-base" />;
};

export default HeaderWalletDrawerTronWallet;
